import { withStyles } from '@material-ui/core'
import { Translation } from 'react-i18next'
import FontAwesome from 'react-fontawesome'
import { useSelector } from 'react-redux'
import {
  getOfferedFromLightEntre,
  getTotalApplication
} from '../../../selectors/employer/applications.selector'

const styles = () => ({
  link: {
    display: 'flex',
    alignItems: 'center'
  }
})

const front = (concept) => {
  switch (concept) {
    case 'LIGHT_ENTREPRENEURS':
      return 'employer.nav2.lightE'
    case 'ASSIGNMENTS':
      return 'employer.nav2.assignments'
    case 'APPLICATIONS':
      return 'employer.nav2.app'
    case 'WORKSHIFTS':
      return 'employer.nav2.work'
    case 'PROFILE':
      return 'employer.dashboard.asetu'
  }
}

const NavIconHorizontal = ({ classes, name, size, iconClass, content }) => {
  const getTotalApplicationCount = useSelector(getTotalApplication)
  const getOfferedFromLightEntreCount = useSelector(getOfferedFromLightEntre)
  const newApplicationStatusNotification = getOfferedFromLightEntreCount.find(
    (item) =>
      item.agreement_status_entrepreneur === 'Offer accepted by entrepreneur' &&
      item.is_contract_viewed === 0
  )

  return (
    <Translation>
      {(t) => {
        return (
          <div className={classes.link}>
            <FontAwesome
              name={name}
              size={size}
              className={iconClass}
              style={{ marginRight: '10px' }}
            />
            <p style={{ margin: '0', textAlign: 'left' }}>
              {t(front(content))}{' '}
              {content === 'APPLICATIONS'
                ? (getTotalApplicationCount.total_application ?? 0) +
                  '(' +
                  (getTotalApplicationCount.total_newapplication ?? 0) +
                  '\u00a0new)'
                : null}
            </p>
            {content === 'APPLICATIONS' &&
              !!newApplicationStatusNotification && (
                <p
                  style={{
                    position: 'absolute',
                    right: '0',
                    top: '8px',
                    color: '#F67131',
                    fontSize: '10px'
                  }}
                >
                  <FontAwesome name="circle" />
                </p>
              )}
          </div>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(NavIconHorizontal)
